// サイドナビの製品バナー非表示
//
// メディカルアフェアーズ（疾患情報）の対象ページでは、サイドナビの
// 製品バナー（アリケイス・ブリヌスプリ）を表示しない。
// 対象ページ・対象バナーの追加・削除は各配列の変更だけで済む。

// 完全一致で対象にするパス
const TARGET_PATHS = [
  '/medical-affairs/',
];

// 前方一致（配下すべて）で対象にするパス
const TARGET_PREFIXES = [
  '/medical-affairs/seminar/',
];

// 非表示にするバナーのリンク先
const BANNER_HREF_PATHS = [
  '/product/arikayce/',
  '/product/brinsupri/',
];

export const initHideProductBanners = () => {
  const { pathname } = location;

  const isTarget =
    TARGET_PATHS.includes(pathname) ||
    TARGET_PREFIXES.some((prefix) => pathname.startsWith(prefix));
  if (!isTarget) return;

  // href は URL として正規化してから比較する（相対・絶対の表記差を吸収）
  document.querySelectorAll('.side-nav > .item[href]').forEach((item) => {
    if (BANNER_HREF_PATHS.includes(new URL(item.href, location.origin).pathname)) {
      item.remove();
    }
  });
};
